import { SelectOptions } from '../../../../React/Common/Components/Selects'

export interface AdminControlFields extends Record<string, string> {
    action: AdminAction
    partitionId: string
    telsysId: string
}

export type ActionType = 'string' | 'boolean' | 'list' | 'password' | 'device' | 'textarea'

export type ActionField = {
    id: string
    label: string
    type: ActionType
    options?: SelectOptions<string | number>
    required?: boolean
}

export enum AdminAction {
    MakeCall = 'MC',
    ConsultationCall = 'MCC',
    DialDTMFTone = 'MDT',
    ClearCallViaCallControl = 'CC',
    ClearCallViaCallModel = 'CCCM',
    ClearConnection = 'CX',
    AnswerCall = 'AC',
    HoldCall = 'HD',
    ParkCall = 'PC',
    RetrieveCall = 'RC',
    AlternateCall = 'ATC',
    PickupCall = 'PUC',
    TransferOneStep = 'TO',
    TransferComplete = 'TR',
    DivertDeflectCall = 'DF',
    MonitorConnection = 'MONC',
    RecordCall = 'REC',
    RegisterCallback = 'CBMSG',
    ConferenceJoin = 'CO',
    MonitorStart = 'MES',
    MonitorStop = 'MEP',
    SetDNDStatus = 'SDND',
    SetACDStat = 'SACD',
    SetForwardStatus = 'SFWD',
    SetAccountCode = 'SACC',
    SetEntityPassword = 'SPWD',
    QueryDNDStat = 'QDND',
    QueryACDStat = 'QACD',
    QueryForwardStatus = 'QFWD',
    SnapshotCall = 'SPC',
    SnapshotDevice = 'SPD',
    GetUserCompliancePolicy = 'GUC',
    ApplyAkixiCapturePolicy = 'AAP',
    QueryPresenceStatus = 'QPS',
    DeleteUserPolicy = 'DUP',
    GetTenant = 'GT',
    DeleteTenant = 'DT',
    GetUsers = 'GU',
    GetVoiceApps = 'GVA'
}

export enum MonitorType {
    SilentMonitor,
    ForcedIntrude
}

export enum AcdStatus {
    SignIn = 0,
    SignOut = 1,
    Available = 10,
    NotAvailable = 15,
    AlertingAcd = 20,
    AlertingNonAcd = 21,
    BusyAcd = 30,
    BusyNonAcd = 31,
    BusySupervisor = 32,
    AcdDnd = 40,
    WrapUp = 50
}

export enum ForwardStatus {
    None,
    Immediate,
    OnBusy,
    NoAnswer,
    OnDND,
    OnOOS
}
